import axiosAuth from '../../axiosMain';

async function store(data) {
  let response = await axiosAuth.post('/extract_data', data);
  return response.data;
}

export default {
  store,
};
